<div style="width: fit-content;" class="d-flex ms-2 align-items-center justify-content-center">
  <i [ngClass]="{ 'text-success': isVerified, 'text-muted': !isVerified }"
    [class]="'ti ' + (isVerified ? 'ti-circle-check' : 'ti-circle-x')" style="font-size: 22px"></i>
</div>